let sField = "", sOrder = "";

function compare(a: any, b: any) {
  let aVal = "", bVal = "";
  if (sField) {
    if (sField === "firstlastname") {
      if (a['firstName'] && a['firstName'].trim()) {
        aVal += a['firstName'].trim();
      }
      if (a['lastName'] && a['lastName'].trim()) {
        aVal += ` ${a['lastName'].trim()}`;
      }
      if (!aVal && a['email']) aVal += a['email'].trim().toLocaleLowerCase();
      else aVal = aVal.trim().toLocaleLowerCase();
      if (b['firstName'] && b['firstName'].trim()) {
        bVal += b['firstName'].trim();
      }
      if (b['lastName'] && b['lastName'].trim()) {
        bVal += ` ${b['lastName'].trim()}`;
      }
      if (!bVal && b['email']) bVal += b['email'].trim().toLocaleLowerCase();
      else bVal = bVal.trim().toLocaleLowerCase();
    } else {
      aVal = a[sField]?.toLocaleLowerCase();
      bVal = b[sField].toLocaleLowerCase();
    }

    if (aVal === "none" || bVal === "none") {
      return a[sField].toLocaleLowerCase() === "none" ? 1 : -1;
    }
    if (aVal < bVal) {
      return sOrder === "desc" ? 1 : -1;
    }
    if (aVal > bVal) {
      return sOrder === "desc" ? -1 : 1;
    }
  }
  return 0;
}

export const sortDataFunc = (data: any, sortField: any, sortOrder: string) => {
  var sortData = data && [...data];
  sField = sortField;
  sOrder = sortOrder;
  if (sortData?.length > 0) {
    if (!sField) {

      sOrder === "desc" ? sortData?.sort()?.reverse() : sortData?.sort();
    } else {
      sortData?.sort(compare);
    }
  }

  return sortData;
}

